var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"langDropDown"},_vm._l((_vm.langMenuList),function(item,index){return _c('div',{key:index,staticClass:"item",class:{ active: item.label === _vm.language },on:{"click":function($event){return _vm.changeLang(item.label)}}},[_vm._v(" "+_vm._s(item.value)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }